export default [
  '/tmic/',
  '/tmic/auto/',
  '/tmic/homeowner/',
  '/tmic/manage-policy/',
  '/tmic/motorcycle/',
  '/tmic/products/',
  '/tmic/why-tmic/',
];
